import { useEffect, useState } from "react";
import { Typography, ListItem, Collapse } from "@mui/material";
import { tss } from "tss-react/mui";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { sectionHeaderColor } from "styles/common";
import { alpha } from '@mui/material/styles';

const useStyles = tss.create(({ theme }) => ({
    sectionContainer: {
        borderTop: `solid 1px ${theme.palette.divider}`,
        lineHeight: 0,
        background: alpha(theme.palette.background.paper, 0.8)
    },
    sectionHeader: {
        margin: 0,
        width: "100%",
        display: "inline-flex",
        marginLeft: 10,
    },
    sectionLabel: {
        margin: 0,
        marginLeft: -5,
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        color: theme.palette.text.primary,
    },
    arrow: {
        width: 16,
        height: 16,
        position: "relative",
    },
    listItem: {
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: alpha(theme.palette.background.paper, 0.8),
        "&:hover": {
            backgroundColor: alpha(theme.palette.background.paper, 0.8),
        },
    },
}));

var collapseState: any = {};

type IProps = {
    name: string;
    label: string;
    icon?: any;
    children?: any;
    style?: any;
    onCollapse?: (name: string, value: boolean) => void;
};

export default function Section(props: IProps) {
    var { name, label, icon, children, style, onCollapse } = props;
    const { classes } = useStyles();
    if (!collapseState[name]) {
        collapseState[name] = false;
    }
    var [open, setOpen] = useState(collapseState[name]);
    useEffect(() => {
        return () => {
            collapseState[name] = false;
        };
    }, [name]);
    const toggleCollapse = () => {
        setOpen(!open);
        collapseState[name] = !open;
        if (onCollapse) {
            onCollapse(name, !open);
        }
    };
    return (
        <div className={classes.sectionContainer} style={style}>
            <ListItem onClick={toggleCollapse} className={classes.listItem}>
                {open ? <ExpandLess className={classes.arrow} /> : <ExpandMore className={classes.arrow} />}
                <div className={classes.sectionHeader}>
                    {icon}
                    <Typography className={classes.sectionLabel}>{label}</Typography>
                </div>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit style={{ marginLeft: 10 }}>
                {children}
            </Collapse>
        </div>
    );
}
